import { MEXICO_PROVINCES } from "_common/regions/regions";
import { TAttraction } from "../attractions";
import { ATTRACTION_TYPE } from "_common/attractions/type/attraction.type";

export const jaliscoAttraction: TAttraction[] = [
    {
        name: "Guadalajara International Airport (GDL)",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5255415,
            lng: -103.3122233,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "Licenciado Gustavo Díaz Ordaz International Airport (PVR)",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.6805184,
            lng: -105.2549565,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "PV Playa el Sabado",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.6373104,
            lng: -105.275818,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "PV Playa del Holi",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.6431157,
            lng: -105.2408836,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "PV Playa de Las Glorias",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.6307817,
            lng: -105.2328283,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "PV Playa Camarones",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.6191208,
            lng: -105.2324004,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Malecón de Puerto Vallarta",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.6123865,
            lng: -105.2442874,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "PV Playa de Los Muertos",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5979701,
            lng: -105.2396244,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "PV Playa Amapas",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.594954,
            lng: -105.2410878,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Conchas Chinas",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5912227,
            lng: -105.2440739,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Las Estacas",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5832907,
            lng: -105.2445311,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Punta Negra",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5628249,
            lng: -105.2550638,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Palmares",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5585352,
            lng: -105.2573903,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa La Garza Blanca",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5513777,
            lng: -105.2696766,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Paredón",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5476285,
            lng: -105.2772842,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Colomitos",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5119809,
            lng: -105.3256966,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "PLAYA HACAMIYA",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5125374,
            lng: -105.3310299,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Caballo",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5099811,
            lng: -105.3388231,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Las Ánimas",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5070549,
            lng: -105.3443948,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Navidad",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 19.203789,
            lng: -104.684458,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa La Manzanilla",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 19.2831571,
            lng: -104.7884415,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Las Caletas, Cabo Corrientes",
        region: MEXICO_PROVINCES.JALISCO,
        coordinates: {
            lat: 20.5046173,
            lng: -105.3819935,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
];
